import React 			from 'react';
import {Breadcrumb,Spin,message,Form,Input,Switch,Button,Typography} from 'antd';
import {Link}     from 'react-router-dom';
import styles from './homePage.module.css';

const {Title,Text} = Typography;
 
class Error extends React.Component {
	constructor(props){
		super(props)
	}
	render(){
		return (
			<div className="tc">
				<Title level={2}>出错啦！</Title>
				<div className="row" style={{marginTop:'30px'}}>
					<div className="col-md-12">
						<span>页面不存在，请确认页面地址正确～～～</span>
						<p className="mt10"><Button type="primary"><Link to='/'>点我返回首页</Link></Button></p>
					</div>
				</div>
 
			</div>
		)
	}
}

export default Error